export enum StatePieceStatus {
    None,
    IsFetching,
    Error,
    NotFound,
    UnAuthorized,
    Success,
}
